import { Theme } from "@mui/material";
import { lighten } from "@mui/material/styles";
import { CostType } from "../../shared/CaseConfiguration.ts";

/**
 * Costs spent and costs still to come are two tints of the primary colour,
 * the darker one for what is spent. Each is a solid colour, so it also reads
 * in a swatch or a thin bar, where a translucent fill without its outline all
 * but vanishes.
 */
const INCURRED_LIGHTEN = 0.2;
const ESTIMATED_LIGHTEN = 0.7;
/** Costs not to be spent are an outline of a tint between the two. */
const NOT_TO_BE_SPENT_LIGHTEN = 0.45;

export function getColorForCosts(
  costType:
    | CostType
    | "incurred"
    | "estimated"
    | "dropped"
    | "notToBeSpent",
  theme: Theme,
): { backgroundColor: string; borderColor: string } {
  switch (costType) {
    // spent, and dropped by a settlement: the darkest tint
    case "dropped":
      return {
        backgroundColor: theme.palette.primary.dark,
        borderColor: theme.palette.primary.dark,
      };
    // no fill: the outline is what is left of them
    case "notToBeSpent":
      return {
        backgroundColor: "transparent",
        borderColor: lighten(theme.palette.primary.main, NOT_TO_BE_SPENT_LIGHTEN),
      };
    case "incurred": {
      const color = lighten(theme.palette.primary.main, INCURRED_LIGHTEN);
      return { backgroundColor: color, borderColor: color };
    }
    case "estimated": {
      const color = lighten(theme.palette.primary.main, ESTIMATED_LIGHTEN);
      return { backgroundColor: color, borderColor: color };
    }
    case "otherDisbursement":
      return {
        backgroundColor: theme.palette.primary.main + "90",
        borderColor: theme.palette.primary.dark,
      };
    case "lawFirmFee":
      return {
        backgroundColor: theme.palette.info.light + "80",
        borderColor: theme.palette.info.main,
      };
    case "courtFee":
      return {
        backgroundColor: theme.palette.data.positive.main + "80",
        borderColor: theme.palette.data.positive.dark,
      };
    case "barristerFee":
      return {
        backgroundColor: theme.palette.warning.light + "80",
        borderColor: theme.palette.warning.main,
      };
    case "expertFee":
      return {
        backgroundColor: theme.palette.data.negative.main + "80",
        borderColor: theme.palette.data.negative.dark,
      };
  }
}
